<div class="modal-content">
  <div class="modal-header">
    <div class="pb-4">
      <i aria-label="Close" (click)="handleClick()" class="close pull-right align-middle fas fa-times"> </i>
    </div>
    <h4 class="modal-title" data-cy="transportOrderRefundDialogHeading" jhiTranslate="OFFER_MODIFICATION.MODAL.UPLOAD_PRICING.TITLE"></h4>
  </div>
  <jhi-upload-pricing-how-to [offer]="offer" [showTitle]="false"></jhi-upload-pricing-how-to>
</div>
